// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"f72d404d","787":"a2ef8559","806":"e22ecfd0"}[chunkId] + ".chunk.js";
};